import React, { useState } from 'react'
import { IkonContainerHjaelptilsagsbehandling } from '../../../../assets/icons'
import SvgChevronLeft from '../../../../assets/icons/ChevronLeft'
import { colors } from '../../../../theme/palette'
import { L } from '../../../providers/Lokalise'
import { Circle } from '../../../ui/Card'
import { CardColumn } from '../../../ui/Card/CardColumn'
import { CircleIcon } from '../../../ui/Circle/Circle'
import { Typography } from '../../../ui/Typography/Typography'
import { useStyles } from '.'

export const CaseHelpColumn = (): JSX.Element => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const toggleOpen = (): void => {
        setOpen(!open)
    }

    return (
        <CardColumn
            titleLabel="Hjælp til sagsbehandling"
            titleIcon={<IkonContainerHjaelptilsagsbehandling />}
            hideTitle
            rows={[
                {
                    label: '',
                    value: '',
                    useContent: true,
                    content: (
                        <div
                            style={{
                                width: '100%',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <div className={classes.titleContainer}>
                                <Circle>
                                    <CircleIcon>
                                        <IkonContainerHjaelptilsagsbehandling
                                            style={{
                                                fill: colors.green600,
                                            }}
                                        />
                                    </CircleIcon>
                                </Circle>
                                <Typography
                                    tag="h3"
                                    size="M"
                                    spacing=".2rem"
                                    weight="bold"
                                >
                                    {L(
                                        'LØN_DETALJE_HJÆLP_TIL_SAGSBEHANDLING_CONTAINER_TITEL'
                                    )}
                                </Typography>
                                <button
                                    type="button"
                                    onClick={toggleOpen}
                                    aria-expanded={open}
                                    className={classes.accordionButton}
                                >
                                    <SvgChevronLeft />
                                </button>
                            </div>
                            <div
                                className={`${classes.accordionContent}${
                                    open ? ' open' : ''
                                }`}
                            >
                                <div
                                    style={{
                                        overflow: 'hidden',
                                    }}
                                >
                                    <a
                                        href={L('LØN_DETALJE_HJÆLP_LINK_1_URL')}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {L('LØN_DETALJE_HJÆLP_LINK_1_TEKST')}
                                    </a>
                                    <a
                                        href={L('LØN_DETALJE_HJÆLP_LINK_2_URL')}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {L('LØN_DETALJE_HJÆLP_LINK_2_TEKST')}
                                    </a>
                                    <a
                                        href={L('LØN_DETALJE_HJÆLP_LINK_3_URL')}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {L('LØN_DETALJE_HJÆLP_LINK_3_TEKST')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    ),
                },
            ]}
        />
    )
}
